import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatButton, MatIconButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatToolbar } from '@angular/material/toolbar'
import { ElderThemeDirective } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { StorageNode } from '../storage-node'
import { StorageNodeTableComponent } from '../storage-node-table/storage-node-table.component'

export class IStorageNodeSelectionDialogOptions {
  readonly storageNodesIds: string[]
}

@Component({
  selector: 'app-storage-node-selection-dialog',
  templateUrl: './storage-node-selection-dialog.component.html',
  styleUrls: ['./storage-node-selection-dialog.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatIcon,
    MatButton,
    StorageNodeTableComponent,
    ElderTranslatePipe,
  ],
})
export class StorageNodeSelectionDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public storageNodesIds: string[]
  public selectedNode: StorageNode

  private dialogRef = inject<MatDialogRef<StorageNodeSelectionDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IStorageNodeSelectionDialogOptions>(MAT_DIALOG_DATA)
    this.storageNodesIds = data.storageNodesIds
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public close(node?: StorageNode): void {
    this.dialogRef.close(node)
  }
}
